module.exports = __webpack_public_path__ + "img/ta-ny-leftTitle02keliwu03.5c0e4082.png";